import { sendEmailVerification, signOut } from 'firebase/auth'
import { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { auth } from '../../config/firebase'
import { useSelector } from 'react-redux'
import {
  selectIsAuthenticated,
  selectAuthUser,
  selectUserId,
} from '../slices/userSlice'

export const useAuth = () => {
  const [logoutDisabled, setLogoutDisabled] = useState(false)
  const navigate = useNavigate()

  const userId = useSelector(selectUserId)
  const authUser = useSelector(selectAuthUser)
  const isAuthenticated = useSelector(selectIsAuthenticated)

  const onLogout = useCallback(() => {
    setLogoutDisabled(true)
    signOut(auth)
      .then(() => {
        navigate('/login')
      })
      .catch((error) => {
        console.error(error)
        setLogoutDisabled(false)
      })
  }, [navigate])

  const onSendVerificationEmail = useCallback(() => {
    if (authUser && auth.currentUser) {
      sendEmailVerification(auth.currentUser)
    }
  }, [authUser])

  return {
    userId,
    authUser,
    isAuthenticated,
    logoutDisabled,
    onLogout,
    onSendVerificationEmail,
  }
}
